const data = (fileName: string) => {
    return {
        id: Math.random().toString(),
        isSuccessful: true,
        fileName,
    };
};

export default data;
